import { useEffect, useState } from 'react';

export const useGetErrorMessage = (error?: Response) => {
  const [errorMessage, setErrorMessage] = useState<string | null>();
  const [showErrorDialog, setShowErrorDialog] = useState(false);

  useEffect(() => {
    if (error) {
      error
        .clone()
        .json()
        .then((errorData: { message?: string; detail?: string; title?: string; userMessage?: string }) => {
          setErrorMessage((errorData?.detail || errorData.title) ?? (errorData.userMessage || errorData.message));
          setShowErrorDialog(true);
        });
    } else {
      setErrorMessage(undefined);
      setShowErrorDialog(false);
    }
  }, [error]);

  return [errorMessage, showErrorDialog, setShowErrorDialog] as const;
};
